module.exports = __webpack_public_path__ + "static/media/3.4163b01c.jpg";